import { Timestamp } from '@dixa/lib-shared-habla';
import { ampli } from 'lib-shared-tracking';

import { SubTitleRendererParams } from '../../subTitleRenderers';

export function conversationHistorySubTitleRenderer(
  params: SubTitleRendererParams,
) {
  const { metaConversation } = params;
  const { conversation } = metaConversation;
  const { last_message_created_at: lastMessageCreatedAt, queue } = conversation;

  const separator = ' · ';
  const CSID = metaConversation.conversation.id;

  return (
    <>
      {CSID && <span>{`#${CSID}`}</span>}

      {lastMessageCreatedAt && (
        <>
          {separator}
          <span
            onClick={() =>
              ampli.conversationsTimestampClicked({
                context: 'created',
              })
            }
          >
            <Timestamp relative time={lastMessageCreatedAt} />
          </span>
        </>
      )}

      {queue && (
        <>
          <span>{separator}</span>
          <span>{queue.name}</span>
        </>
      )}
    </>
  );
}
